// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MSPv5","imageLink":"mNIsJ","image":"_4f5uK"};